<template>
 <DxPopup :visible="open" :ref="refPopup" title="Solicitud de soporte" :drag-enabled="true" :hide-on-outside-click="false"
    :show-close-button="false" @hidden="onHidden" :show-title="true" :width="620" :height="600" :shading="false"
    class="popup-import-users">
    <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="sendButtonOptions" />
    <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="cancelButtonOptions" />
    <div>
      <p style="text-align:justify;"><b>Por favor llene los campos requeridos. Será contactado lo mas pronto posible a su correo electrónico.</b></p>
    </div>
        <DxForm
          :read-only="false"
          v-model:form-data="data_user"
          :show-colon-after-label="true"
          :show-validation-summary="true"
          validation-group="customerData"
        >
          <DxGroupItem :col-count="2">
            <DxSimpleItem data-field="email" :editor-options="{width:300}">
              <DxLabel text="Verifique su Correo Electrónico"/>
              <DxRequiredRule message="Email is required"/>
              <DxEmailRule message="Email is invalid"/>
            </DxSimpleItem>
            <DxSimpleItem
              :editor-options="optionSubject()"
              data-field="subject"
              editor-type="dxSelectBox"
            >
              <DxLabel text="Asunto"/>
              <DxRequiredRule message="Asunto is required"/>
            </DxSimpleItem>
          </DxGroupItem>

          <DxGroupItem >
            <DxSimpleItem data-field="message" editor-type="dxTextArea" :editor-options="{width:500,height:100}">
               <DxLabel text="Mensaje"/>
              <DxRequiredRule message="Mensaje is required"/>
              
            </DxSimpleItem>
            <DxSimpleItem
              :editor-options="{ uploadMode:'useForm'}"
              data-field="files"
              editor-type="dxFileUploader"
            >
              <DxLabel text="Si lo requiere, adjunte un archivo que complemente su mensaje."/>
            </DxSimpleItem>
          </DxGroupItem>
        </DxForm>
</DxPopup>
</template>
<script>
/* eslint-disable */
import 'devextreme/dist/css/dx.common.css';
import '../../themes/generated/theme.base.css';
import '../../themes/generated/theme.additional.css';
import DxPopup, { DxToolbarItem } from "devextreme-vue/popup";
import DxForm, {
  DxGroupItem,
  DxSimpleItem,
  DxButtonItem,
  DxLabel,
  DxRequiredRule,
  DxCompareRule,
  DxRangeRule,
  DxStringLengthRule,
  DxPatternRule,
  DxEmailRule,
  DxAsyncRule,
} from 'devextreme-vue/form';
import DxAutocomplete from 'devextreme-vue/autocomplete';
import notify from 'devextreme/ui/notify';
import auth from "@/auth";
import http from "../../api/http";
var ui = require("../../plugins/busyUi").default;
const refPopup = "modal-support";
var _this = null
export default {
  name: "component-support",
  components: {
    DxPopup,
    DxToolbarItem,
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    DxRequiredRule,
    DxCompareRule,
    DxPatternRule,
    DxRangeRule,
    DxEmailRule,
    DxStringLengthRule,
    DxForm,
    DxAutocomplete,
    DxAsyncRule,
    notify,
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      refPopup,
      data_user: {
        email:auth.get_user_email(),
        subject:'',
        message:'',
        files:[]
      },
      sendButtonOptions: {
        text: 'Enviar',
        validationGroup: "customerData",
        onClick: (e) => {
          if (!e.validationGroup.validate().isValid) {
            return;
          }
          var formData = {
          email:_this.data_user.email,
          subject:_this.data_user.subject,
          message:_this.data_user.message,
          file:(_this.data_user.files.length>0? _this.data_user.files[0]:'')
          };
          ui.busyUi(true, $(_this.Popup._$element[0]));
            http.post("support", formData)
              .then((response) => {
                ui.busyUi(false, $(_this.Popup._$element[0]));
                if (response.STATUS_CODE == 1) {
                  notify(
                  {
                    message: "La solicitud de soporte fué registrada...",
                    width: "auto",
                    shading: false,
                  },
                  "success",
                  1200
                  );
                  _this.Popup.option('visible', false);
                } else {
                  notify(
                    {
                      message: response.RESPONSE_DESCRIPTION,
                      width: "auto",
                      shading: false,
                    },
                    "error",
                    1100
                  );
                }
              })
              .catch((error) => {
                console.error("Error de conexión", error);
                ui.busyUi(false, $(_this.Popup._$element[0]));
                notify(
                    {
                      message: error,
                      width: "auto",
                      shading: false,
                    },
                    "error",
                    1100
                  );
              });
        },
      },
      cancelButtonOptions: {
        text: 'Cancelar',
        onClick: () => {
          _this.Popup.option('visible', false);
        }
      }
    };
  },

  methods: {
    onHidden() {
      _this.data_user.email = auth.get_user_email();
      _this.data_user.subject = '';
      _this.data_user.message = '';
      _this.data_user.files = [];
      _this.Popup.option('visible', false);
      this.$store.commit('SetModalSupport');
    },
    optionSubject() {
            return {
                width: 200,
                dataSource: [{name:'Requerimiento'},{name:'Información'},{name:'Sugerencia'},{name:'Queja'},{name:'Felicitación'}],
                valueExpr: 'name',
                displayExpr: 'name',
                onValueChanged: function (e) {
                    
                }
            }
        },
  },
  beforeDestroy() {
    this.$refs['modal-support'].instance.option('visible', false);
    this.$refs['modal-support'].instance.dispose();
  },
  mounted() {
    _this = this
    this.Popup = this.$refs[refPopup] && this.$refs[refPopup].instance;
  }
};
</script>